import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import React, { Fragment, useState } from 'react'
import { UsuarioEdicaoFirstPage } from '../components/UsuarioFirstPage/usuario-edicao-first-page'
import { UsuarioEdicaoSecondPage } from '../components/UsuarioSecondPage/usuario-edicao-second-page'
import { useUsuarioEdicaoForm } from '../hooks/use-form'
import { useUsuarioEdicaoQueryHandler } from '../hooks/use-query-handler'
import { FormWizard } from '../../hook-form-connectors/form-wizard'

export const UsuarioEdicaoWizard = () => {
  const { initialValues, schemaArray, submitHandler, onClose, allDataLoaded } =
    useUsuarioEdicaoForm()

  const { tiposMap } = useUsuarioEdicaoQueryHandler()

  const [activeStep, setActiveStep] = useState(0)

  return (
    <div className={'h-[80vh]'}>
      <div className={'mb-deca'}>
        <p className={'font-bold text-h1 w-full'}>
          {initialValues.id ? initialValues.nome : <Trans>Novo Usuário</Trans>}
        </p>
      </div>
      <FormWizard
        initialValues={initialValues}
        schemaArray={schemaArray}
        submitHandler={submitHandler}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        onClose={onClose}
        canInitialize={allDataLoaded}
      >
        <>
          <Fragment key='dados-basicos'>
            <UsuarioEdicaoFirstPage {...tiposMap} title={t`Dados Básicos`} />
          </Fragment>
          <Fragment key='permissoes'>
            <UsuarioEdicaoSecondPage title={t`Permissões`} />
          </Fragment>
        </>
      </FormWizard>
    </div>
  )
}

export default UsuarioEdicaoWizard
